export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20" data-testid="about-page">
      <div className="eyebrow mb-4">Our Editorial Vision</div>
      <h1 className="font-serif text-5xl md:text-6xl text-forest-900 leading-tight">A quiet desk for thoughtful readers.</h1>
      <div className="article-body mt-10">
        <p className="lead">
          Githy began with a simple frustration: the modern internet rewards speed and noise, and we wanted a quieter place to think and connect.
        </p>
        <p>
          We publish long-form essays across six sections - Travel, Tech, Finance, Ecommerce, Sports, and Trading and Investment - written for readers who&apos;d rather think than scroll. Every essay is carefully shaped by our editorial team with substance, clarity, and patience in mind.
        </p>
        <h2>Our Editorial Standards</h2>
        <p>
          When we recommend a product, we&apos;ve used it. When we cover a destination, we&apos;ve done thorough research. When we discuss money, we share expert-informed opinions. Sponsored content, when it appears, is clearly identified.
        </p>
        <p>
          We aim to create articles that are useful beyond the news cycle. That means fewer rushed takes, more context, and a steadier reading experience for people who value depth over noise.
        </p>
        <h2>Get in Touch</h2>
        <p>
          If you&apos;d like to reach us, the contact page is the best place to start. We typically reply within two days and read every thoughtful message that comes in.
        </p>
        <h2>The Team</h2>
        <p>
          Githy is a small team of contributors with strong experience in their key areas. We work deliberately and collaboratively to publish pieces that reward a slower, more attentive reader.
        </p>
      </div>
    </div>
  );
}
